import type { ReactNode } from "react";

/** Title across the page, with the aside lined up to the content beneath it. */
export function StartingTeacherRouteFrame({
  header,
  headerAction,
  aside,
  children,
  controlId,
  asideAlign = "page",
}: {
  header: ReactNode;
  headerAction?: ReactNode;
  aside: ReactNode;
  children: ReactNode;
  controlId?: string;
  /** `content` keeps the title in the left column and lines the aside up with the cards. */
  asideAlign?: "page" | "content";
}) {
  return (
    <div
      className="grid items-start gap-x-6 gap-y-8 xl:grid-cols-[minmax(0,1.6fr)_minmax(0,1fr)]"
      data-control-id={controlId}
    >
      {asideAlign === "content" ? (
        <>
          <div className="min-w-0">{header}</div>
          <div className={headerAction ? "flex justify-end xl:col-start-2 xl:row-start-1" : "hidden xl:block"}>
            {headerAction}
          </div>
        </>
      ) : (
        <div className="min-w-0 xl:col-span-2">{header}</div>
      )}
      <div className="min-w-0">{children}</div>
      <aside className="min-w-0">{aside}</aside>
    </div>
  );
}
